import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, Alert } from "react-bootstrap";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config.json";
import DocumentList from "./DocumentList";

const ESGDocumentLibrary = (props) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDocuments = async () => {
    setLoading(true);
    setError(null);
    let docType = ['ESG_DOCUMENT_LIBRARY']

    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}documents`,
        {},
        {documentType:JSON.stringify(docType)},
        "GET"
      );

      if (isSuccess && data?.documents) {
        setDocuments(data.documents);
      } else {
        setError("Failed to load documents");
      }
    } catch {
      setError("Something went wrong while fetching documents");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return (
    <div className="d-flex flex-row mainclass" style={{ height: "100vh", overflow: "auto" }}>
      <div style={{ flex: sidebarExpanded ? "0 0 21%" : "0 0 60px", position: "sticky", top: 0, zIndex: 999 }}>
        <Sidebar dataFromParent={props.location.pathname} onSidebarToggle={setSidebarExpanded} />
      </div>

      <div style={{ flex: "1", transition: "all 0.3s ease" }}>
        <div style={{ position: "sticky", top: 0, zIndex: 999 }}><Header /></div>

        <div className="content-wrapper p-4">
        

          {error && <Alert variant="danger">{error}</Alert>}

          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <DocumentList
              documents={documents}
              onRefresh={fetchDocuments}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ESGDocumentLibrary;
